export const generateUniqueColors = (count) => {
  return Array.from({ length: count }, (_, i) => {
    const hue = (i * 137.508) % 360;
    return `hsl(${hue}, 65%, 35%)`;
  });
};

export const STATUS_COLORS = {
  positive: "#16a34a",
  negative: "#eb4438",
  warning: "#c96f1a",
  info: "#13a8ce",
  neutral: "#868d36",
  muted: "#36360e",
  block: "#4d4744",
  review: "#7e151571",
  approvedBlue: "#3B82F6",
  pendingLightBlue: "#93C5FD",
  submitted: "#10B981",
  selectedRfq: "#EF4444",
  closedRfq: "#000000",
  pendingRfq: "#FBBF24",
  invited: "#3B82F6",
  others: "#1E3A8A",
  openGrn: "#3B82F6",
  closedGrn: "#10B981",
  rejectedInvoice: "#6B7280",
  cancelled: "#EF4444",
};

const STATUS_KEYWORDS = [
  { keys: ["rejected", "cancel", "failed", "unselected"], color: STATUS_COLORS.negative },
  { keys: ["approved", "selected", "signed", "completed", "onboarded"], color: STATUS_COLORS.positive },
  { keys: ["pending", "unsubmitted"], color: STATUS_COLORS.warning },
  { keys: ["open", "submitted", "received", "initiated"], color: STATUS_COLORS.info },
  { keys: ["closed"], color: STATUS_COLORS.block },
  { keys: ["review"], color: STATUS_COLORS.review },
];

export const DASHBOARD_CHART_PALETTES = {
  buyerDashboard: {
    rfqCreated: [STATUS_COLORS.info],
    submittedSelected: [
      STATUS_COLORS.submitted,
      STATUS_COLORS.selectedRfq,
      STATUS_COLORS.negative,
      STATUS_COLORS.warning,
    ],
    openCancelPending: [
      STATUS_COLORS.cancelled,
      STATUS_COLORS.warning,
      STATUS_COLORS.info,
      STATUS_COLORS.block,
    ],
    totalPurchaseOrders: [STATUS_COLORS.positive],
    totalSpend: [STATUS_COLORS.neutral],
    responseTime: [STATUS_COLORS.warning, STATUS_COLORS.info],
    pendingClosedRfq: [STATUS_COLORS.pendingRfq, STATUS_COLORS.closedRfq],
    vendorSummary: [STATUS_COLORS.invited, STATUS_COLORS.others],
    vendorSelected: [STATUS_COLORS.info],
    vendorOnboarding: [STATUS_COLORS.info, STATUS_COLORS.positive],
    grnSummary: [STATUS_COLORS.openGrn, STATUS_COLORS.closedGrn],
    twmSummary: [
      STATUS_COLORS.positive,
      STATUS_COLORS.warning,
      STATUS_COLORS.review,
      STATUS_COLORS.negative,
    ],
    merchantInvoiceSummary: [
      STATUS_COLORS.positive,
      STATUS_COLORS.info,
      STATUS_COLORS.warning,
      STATUS_COLORS.rejectedInvoice,
    ],
    quotationSummary: [STATUS_COLORS.info, STATUS_COLORS.warning],
    poSummary: [
      STATUS_COLORS.positive,
      STATUS_COLORS.warning,
      STATUS_COLORS.info,
      STATUS_COLORS.negative,
      STATUS_COLORS.block
      
    ],
    prSummary: [
      STATUS_COLORS.approvedBlue,
      STATUS_COLORS.negative,
      STATUS_COLORS.pendingLightBlue,
    ],
  },
  userDashboard: {
    count: [STATUS_COLORS.info],
    prSummary: [
      STATUS_COLORS.approvedBlue,
      STATUS_COLORS.negative,
      STATUS_COLORS.pendingLightBlue,
    ],
    poSummary: [
      STATUS_COLORS.positive,
      STATUS_COLORS.negative,
      STATUS_COLORS.warning,
    ],
    grnOpenClose: [STATUS_COLORS.info, STATUS_COLORS.block],
    approvedRejected: [STATUS_COLORS.positive, STATUS_COLORS.negative],
  },
  buyerAdminDashboard: {
    vendorsAndBuyers: [
      STATUS_COLORS.info,
      STATUS_COLORS.positive,
      STATUS_COLORS.neutral,
    ],
    masterRecords: [STATUS_COLORS.info, STATUS_COLORS.positive],
    accountingCodes: [
      STATUS_COLORS.warning,
      STATUS_COLORS.info,
      STATUS_COLORS.neutral,
    ],
    poSummary: [
      STATUS_COLORS.positive,
      STATUS_COLORS.warning,
      STATUS_COLORS.negative,
    ],
    rfqCreated: [STATUS_COLORS.info],
    submittedSelected: [
      STATUS_COLORS.submitted,
      STATUS_COLORS.selectedRfq,
      STATUS_COLORS.negative,
    ],
    totalSpend: [STATUS_COLORS.neutral],
    responseTime: [STATUS_COLORS.warning, STATUS_COLORS.info],
    pendingClosedRfq: [STATUS_COLORS.pendingRfq, STATUS_COLORS.closedRfq],
    prSummary: [
      STATUS_COLORS.approvedBlue,
      STATUS_COLORS.negative,
      STATUS_COLORS.pendingLightBlue,
    ],
  },
  vendorDashboard: {
    submittedSelected: [
      STATUS_COLORS.submitted,
      STATUS_COLORS.selectedRfq,
      STATUS_COLORS.warning,
    ],
    pendingClosedRfq: [STATUS_COLORS.pendingRfq, STATUS_COLORS.closedRfq],
    totalBidsSubmitted: [STATUS_COLORS.info],
    totalSalesOrder: [STATUS_COLORS.positive],
  },
};

export const getStatusColor = (label, fallback = STATUS_COLORS.neutral) => {
  const normalized = String(label || "").toLowerCase();
  const matchedKeyword = STATUS_KEYWORDS.find(({ keys }) =>
    keys.some((key) => normalized.includes(key))
  );

  return matchedKeyword?.color || fallback;
};
